<template>
  <div>
    <slot></slot>
    <aside v-once>
      <h4 class="lotion-header">Lotion Symbols</h4>
      <p class="lotion-description">
        <span class="symbol Accelerator">Accelerator</span>:
        <base-snippet name="lotion-symbol-accelerator">
          Intensifies the production of melanin and naturally develops color
          without bronzers.
        </base-snippet>
      </p>
      <p class="lotion-description">
        <span class="symbol Cosmetic Bronzer">Cosmetic Bronzer</span>:
        <base-snippet name="lotion-symbol-cosmetic-bronzer">
          Immediate and temporary results with cosmetic color (DHA-free).
        </base-snippet>
      </p>
      <p class="lotion-description">
        <span class="symbol DHA Bronzer">DHA Bronzer</span>:
        <base-snippet name="lotion-symbol-dha-bronzer">
          Delayed DHA Bronzers produce color results within four hours and
          typically last up to seven days.
        </base-snippet>
      </p>
      <p class="lotion-description">
        <span class="symbol Natural Bronzer">Natural Bronzer</span>:
        <base-snippet name="lotion-symbol-natural-bronzer">
          Utilizes natural tanning ingredients, such as Caramel, Henna, and
          Black Walnut. These 'bronzers' are streak free, cosmetic-free, and
          DHA-free.
        </base-snippet>
      </p>
      <p class="lotion-description">
        <span class="symbol Tingle">Tingle</span>:
        <base-snippet name="lotion-symbol-tingle">
          Stimulates and increases microcirculation causing a warming or
          tingling sensation and reddening effect to the skin. For advanced
          tanners only.
        </base-snippet>
      </p>
      <p class="lotion-description">
        <span class="symbol Cooling">Cooling</span>:
        <base-snippet name="lotion-symbol-cooling">
          Cooling sensation during and immediately after tanning.
        </base-snippet>
      </p>
      <p class="lotion-description">
        <span class="symbol Tattoo Protection">Tattoo Protection</span>:
        <base-snippet name="lotion-symbol-tattoo-protection">
          Utilizes essential ingredients that prolong as 
          well as protect the color and vibrancy of tattoos.
        </base-snippet>
      </p>
    </aside>
  </div>
</template>

<script>
  export default {
    name: "base-portal-left-sidebar"
  }
</script>

<style scoped>
  .lotion-header{
    font-size: 12px;
  }
  .symbol{
    font-size: 12px;
  }
  .lotion-description{
    font-size:11px;
    margin-bottom: 8px;
  }
</style>


// WEBPACK FOOTER //
// ixcms/themes/heartlandtan/src/vue-src/base/_base-portal-left-sidebar.vue